import { render, staticRenderFns } from "./UiCheckbox.vue?vue&type=template&id=0fdc7f4c"
import script from "./UiCheckbox.vue?vue&type=script&lang=js"
export * from "./UiCheckbox.vue?vue&type=script&lang=js"
import style0 from "./UiCheckbox.vue?vue&type=style&index=0&id=0fdc7f4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports